import { render, staticRenderFns } from "./spacerBlock.vue?vue&type=template&id=def9b67a&scoped=true"
import script from "./spacerBlock.vue?vue&type=script&lang=js"
export * from "./spacerBlock.vue?vue&type=script&lang=js"
import style0 from "./spacerBlock.vue?vue&type=style&index=0&id=def9b67a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def9b67a",
  null
  
)

export default component.exports